import bilAPI from '../api';

export const postDistrict = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/core/district/', body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchDistrict = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/core/district/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteDistrict = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/core/district/${uuid}/`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getDistrictsFiles = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/district_file/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const uploadDistrictExcel = (file) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post('/core/upload_applicants_file_xlsx/', { file })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getExportExamCenterStats = ({ params }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get('/core/export_exam_centers/', { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
